import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import LoginSection from "../components/LoginSection";
import NewDashboard from "../pages/Dashboard/NewDashboard";
import { appContext } from "../App";
import Header from "../components/Header.js";
import HolidayMaster from "../pages/HolidayMaster";
import IssuerMaster from "../pages/IssuerMaster";
import RatingOrganizationMaster from "../pages/RatingOrganizationMaster";
import SecurityMaster from "../pages/SecurityMaster";
import SecurityType from "../pages/SecurityType";
import Quotes from "../pages/Quotes";
import Users from "../pages/Users/Users";
import DebarredUsers from "../pages/Users/DebarredUsers";
import AdminUserDashboard from "../pages/AdminUsers/AdminUserDashboard";
import AdminUserLogin from "../pages/AdminUsers/AdminUserLogin";
import Subscriptions from "../components/Subscriptions/Subscriptions";
import Newsletter from "../components/Newsletter";
import Orders from "../pages/Orders";
import OrderTable from "../components/Orders/OrderTable";
import PodcastMaster from "../pages/PodcastMaster/PodcastMaster";
import LoyaltyPointsHistory from "../pages/LoyaltyPointsHistory/LoyaltyPointsHistory";
import ActivityLogs from "../pages/ActivityLogs";
import ProfilePage from "../pages/ProfilePage";
import WhatsappCampaign from "../pages/WhatsappCampaign/WhatsappCampaign";
import AllWhatsappMessages from "../pages/WhatsappCampaign/AllWhatsappMessages";
import UserSpecificCategories from "../pages/WhatsappCampaign/UserSpecificCategories";
import EmailVerifications from "../pages/EmailVerifications";
import CashFlowRecords from "../pages/CashFlowRecords";
import Notifications from "../pages/Notifications";
import WhatsappTemplates from "../pages/WhatsappCampaign/WhatsappTemplates";
import BlacklistedUsers from "../pages/BlacklistedUsers/BlacklistedUsers";
import BSEIPOs from "../pages/IPO/BSEIPOs";
import IPOSecurityMaster from "../pages/IPO/IPOSecurityMaster";
import IPOQuotes from "../pages/IPO/IPOQuotes";
import RFQOrders from "../components/RFQOrders/RFQOrders";
import CreateRFQOrder from "../components/RFQOrders/CreateRFQOrder";
import CreateIPOOrder from "../components/IPOOrder/CreateIPOOrder";
import OpenDebtIssues from "../pages/IPO/OpenDebtIssues";
import IPOOrders from "../pages/IPO/IPOOrders";
import GetCategoriesDemand from "../pages/IPO/GetCategoriesDemand";
import IPOBids from "../pages/IPO/IPOBids";
import IssueTime from "../pages/IPO/IssueTime";
import CreateCashflowRecord from "../pages/CreateCashflowRecords";
import RFQOrderDetails from "../components/RFQOrders/RFQOrderDetails";
import NewRFQOrderDetails from "../components/RFQOrders/NewRFQOrderDetails";
import DownloadPermissions from "../pages/Users/DownloadPermissions";
import DeactivateUsers from "../pages/Users/DeactivateUsers";
import GenerateInvoices from "../pages/Users/GenerateInvoices";
import Users15Genie from "../pages/Users/Users15Genie";
import Form121 from "../pages/Users/Form121";
import UpdateUCC from "../components/Users/UpdateUCC";
import YieldCalculator from "../pages/YieldCalculator";
import CreateRFQSellOrder from "../components/RFQSellOrders/CreateRFQSellOrder";
import RFQSellOrders from "../components/RFQSellOrders/RFQSellOrders";
import RFQSellOrderDetails from "../components/RFQSellOrders/RFQSellOrderDetails";
import SendAnnualStatement from "../pages/Users/SendAnnualStatement";
import Anniversary from "../pages/Anniversary";
import BidWars from "../pages/BidWars";
import PriceYieldHistory from "../pages/PriceYieldHistory";
import QuotesDesk from "../pages/QuotesDesk";
import NotFoundPage from "../pages/NotFound";
import Reports from "../pages/Reports";
import UserWishlist from "../components/Quotes/UserWishlist";
import CKYCDashboard from "../pages/Users/CKYCDashboard";
import LiquidationList from "../components/RFQSellOrders/LiquidationList";
import ReferralsUsers from "../pages/Users/ReferralsUsers";
import PartnersUsersDashboard from "../pages/Users/PartnersUsersDashboard";
import PartnerClientUpdateUCC from "../components/PartnerClientDetails/PartnerClientUpdateUCC";
import MutualFundMaster from "../pages/MutualFunds/MutualFundMaster";
import InvestorProfile from "../pages/MutualFunds/InvestorProfile";
import UserInvestmentsDashboard from "../pages/MutualFunds/UserInvestmentsDashboard";
import MFPaymentReturn from "../pages/MutualFunds/MFPaymentReturn";
import PortfolioPlanner from "../pages/MutualFunds/PortfolioPlanner/PortfolioPlanner";
import MFOverview from "../pages/MutualFunds/MFOverview/MFOverview";

const ProtectedRoute = ({
  component: Component,
  permissions,
  authUser,
  ...rest
}) => {
  let permissionsArray;

  if (typeof permissions === "string") {
    try {
      permissionsArray = JSON.parse(permissions);
    } catch (error) {
      console.error("Error parsing JSON string:", error);
    }
  }
  return (
    <Route
      {...rest}
      render={(props) =>
        authUser.isSuperuser ||
          permissionsArray.includes(rest.permissionRequired) ? (
          <Component {...props} />
        ) : (
          <Redirect to="/not-found" />
        )
      }
    />
  );
};

const InvestorProfileRedirect = () => (
  <Redirect to="/mf_investor_profile" />
);

const MainRouter = (props) => {
  const { authUser } = useContext(appContext);
  const currentPermissions = localStorage.getItem("permissions");
  return (
    <Router>
      <Header />
      <div style={{ minHeight: 64 }} />
      <>
        <Route exact path="/" component={LoginSection} />
        <Route exact path="/admin_user/login" component={AdminUserLogin} />

        <Route exact path="/not-found" component={NotFoundPage} />
        <Route exact path="/mf-payment-return" component={MFPaymentReturn} />

        {authUser && authUser.uuid && (
          <Switch>
            <Route exact path="/dashboard" component={NewDashboard} />

            <ProtectedRoute
              exact
              path="/holiday_master"
              component={HolidayMaster}
              permissions={currentPermissions}
              permissionRequired="Holiday Master"
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/issuer_master"
              component={IssuerMaster}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Issuer Master"
            />

            <ProtectedRoute
              exact
              path="/users"
              component={Users}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Users"
            />

            <ProtectedRoute
              exact
              path="/partners_users"
              component={PartnersUsersDashboard}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Partners Users"
            />

            <ProtectedRoute
              exact
              path="/users_15_genie"
              component={Users15Genie}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Users 15 Genie"
            />

            <ProtectedRoute
              exact
              path="/form_121"
              component={Form121}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Form 121"
            />

            <ProtectedRoute
              exact
              path="/cKYC"
              component={CKYCDashboard}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="CKYC Module"
            />

            <ProtectedRoute
              exact
              path="/referrals"
              component={ReferralsUsers}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Referrals List"
            />

            <ProtectedRoute
              exact
              path="/debarred_users"
              component={DebarredUsers}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Users"
            />

            <ProtectedRoute
              exact
              path="/download_permissions"
              component={DownloadPermissions}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Download Permissions"
            />

            <ProtectedRoute
              exact
              path="/deactivate_users"
              component={DeactivateUsers}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Deactivate Users"
            />

            <ProtectedRoute
              exact
              path="/generate_invoices"
              component={GenerateInvoices}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Generate Invoices"
            />

            <ProtectedRoute
              exact
              path="/send_annual_statement"
              component={SendAnnualStatement}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Send Annual Statement"
            />

            <ProtectedRoute
              exact
              path="/bid_wars"
              component={BidWars}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Bid Wars"
            />

            <ProtectedRoute
              exact
              path="/price_yield_history"
              component={PriceYieldHistory}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Orders"
            />

            <ProtectedRoute
              exact
              path="/activity_logs"
              authUser={authUser}
              component={ActivityLogs}
              permissions={currentPermissions}
              permissionRequired="Activity Logs"
            />

            <ProtectedRoute
              exact
              path="/loyalty_points_history"
              component={LoyaltyPointsHistory}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Loyalty Points History"
            />

            <ProtectedRoute
              exact
              path="/cashflow_record/:action/:isin/:uuid"
              component={CreateCashflowRecord}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Security Master"
            />

            <ProtectedRoute
              exact
              path="/ipo_security_master"
              authUser={authUser}
              component={IPOSecurityMaster}
              permissions={currentPermissions}
              permissionRequired="IPO"
            />

            <ProtectedRoute
              exact
              path="/rating_organization_master"
              component={RatingOrganizationMaster}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Rating Organization Master"
            />

            <Route
              exact
              path="/blacklisted_users"
              component={BlacklistedUsers}
            />

            <ProtectedRoute
              exact
              path="/security_type"
              authUser={authUser}
              component={SecurityType}
              permissions={currentPermissions}
              permissionRequired="Security Type"
            />

            <ProtectedRoute
              exact
              path="/security_master"
              authUser={authUser}
              component={SecurityMaster}
              permissions={currentPermissions}
              permissionRequired="Security Master"
            />

            <ProtectedRoute
              exact
              path="/quotes"
              component={Quotes}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Quotes"
            />

            <ProtectedRoute
              exact
              path="/quotes_desk"
              component={QuotesDesk}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Quotes Desk"
            />

            <ProtectedRoute
              exact
              path="/wishlist"
              component={UserWishlist}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Quotes"
            />

            <ProtectedRoute
              exact
              path="/reports"
              component={Reports}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Reports"
            />

            <ProtectedRoute
              exact
              path="/create_rfq_order"
              component={CreateRFQOrder}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Create Orders"
            />

            <ProtectedRoute
              exact
              path="/create_rfq_sell_order"
              component={CreateRFQSellOrder}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Create Sell Orders"
            />

            <ProtectedRoute
              exact
              path="/rfq_orders"
              component={RFQOrders}
              permissions={currentPermissions}
              authUser={authUser}
              permissionRequired="Orders"
            />

            <ProtectedRoute
              exact
              path="/rfq_sell_orders"
              component={RFQSellOrders}
              permissions={currentPermissions}
              authUser={authUser}
              permissionRequired="Create Sell Orders"
            />

            <ProtectedRoute
              exact
              path="/liquidation_list"
              component={LiquidationList}
              permissions={currentPermissions}
              authUser={authUser}
              permissionRequired="Liquidation List"
            />

            <ProtectedRoute
              exact
              path="/rfq_sell_order/:orderUUID/:type"
              component={RFQSellOrderDetails}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Orders"
            />

            <ProtectedRoute
              exact
              path="/new_rfq_orders/:orderUUID/:type"
              component={NewRFQOrderDetails}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Orders"
            />

            <ProtectedRoute
              exact
              path="/update_ucc/:userUUID"
              component={UpdateUCC}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Users"
            />

            <ProtectedRoute
              exact
              path="/partner_client/update_ucc/:userUUID"
              component={PartnerClientUpdateUCC}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Partners Users"
            />

            <ProtectedRoute
              exact
              path="/rfq_orders/:orderUUID"
              component={RFQOrderDetails}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Orders"
            />

            <ProtectedRoute
              exact
              path="/yield-calculator"
              component={YieldCalculator}
              authUser={authUser}
              permissions={currentPermissions}
              permissionRequired="Yield Calculator"
            />

            <ProtectedRoute
              exact
              path="/orders"
              authUser={authUser}
              component={Orders}
              permissions={currentPermissions}
              permissionRequired="Orders"
            />

            <ProtectedRoute
              exact
              path="/orders/:orderUUID"
              authUser={authUser}
              component={OrderTable}
              permissions={currentPermissions}
              permissionRequired="Orders"
            />

            <Route exact path="/profile/:uuid" component={ProfilePage} />
            <Route
              exact
              path="/email_verifications"
              component={EmailVerifications}
            />
            <Route exact path="/cashflow_records" component={CashFlowRecords} />
            <Route exact path="/notifications" component={Notifications} />

            <ProtectedRoute
              exact
              path="/admin_users"
              component={AdminUserDashboard}
              permissions={currentPermissions}
              permissionRequired=""
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/open_debt_issues"
              component={OpenDebtIssues}
              permissions={currentPermissions}
              permissionRequired="IPO"
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/create_ipo_order"
              component={CreateIPOOrder}
              permissions={currentPermissions}
              permissionRequired="Create IPO Orders"
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/ipo_orders"
              component={IPOOrders}
              permissions={currentPermissions}
              permissionRequired="IPO"
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/get_categories_demand"
              component={GetCategoriesDemand}
              permissions={currentPermissions}
              permissionRequired="IPO"
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/ipo_bids"
              component={IPOBids}
              permissions={currentPermissions}
              permissionRequired="IPO"
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/issue_time"
              component={IssueTime}
              permissions={currentPermissions}
              permissionRequired="IPO"
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/bse_ipos"
              component={BSEIPOs}
              permissions={currentPermissions}
              permissionRequired="IPO"
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/ipo_quotes"
              component={IPOQuotes}
              permissions={currentPermissions}
              permissionRequired="IPO"
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/subscriptions"
              component={Subscriptions}
              permissions={currentPermissions}
              permissionRequired="Subscriptions"
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/newsletter"
              component={Newsletter}
              permissions={currentPermissions}
              permissionRequired="Subscriptions"
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/anniversary"
              component={Anniversary}
              permissions={currentPermissions}
              permissionRequired="Subscriptions"
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/podcast_master"
              component={PodcastMaster}
              permissions={currentPermissions}
              permissionRequired=""
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/mutual_funds"
              component={MutualFundMaster}
              permissions={currentPermissions}
              permissionRequired="Mutual Funds"
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/mf_overview"
              component={MFOverview}
              permissions={currentPermissions}
              permissionRequired="MF Overview"
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/mf_investor_profile"
              component={InvestorProfile}
              permissions={currentPermissions}
              permissionRequired="MF Investor Profile"
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/mf_investor_profile/:userUuid/investments"
              component={UserInvestmentsDashboard}
              permissions={currentPermissions}
              permissionRequired="MF Investor Profile"
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/mf_portfolio_planner/:userUuid?"
              component={PortfolioPlanner}
              permissions={currentPermissions}
              permissionRequired="MF Portfolio Planner"
              authUser={authUser}
            />

            <ProtectedRoute
              exact
              path="/whatsapp_campaign"
              component={WhatsappCampaign}
              permissions={currentPermissions}
              permissionRequired="Whatsapp Campaign"
              authUser={authUser}
            />
            <ProtectedRoute
              exact
              path="/whatsapp_templates"
              component={WhatsappTemplates}
              permissions={currentPermissions}
              permissionRequired="Whatsapp Campaign"
              authUser={authUser}
            />
            <ProtectedRoute
              exact
              path="/whatsapp_messages/all"
              component={AllWhatsappMessages}
              permissions={currentPermissions}
              permissionRequired="Whatsapp Campaign"
              authUser={authUser}
            />
            <ProtectedRoute
              exact
              path="/whatsapp_campaign/categories/:userId"
              component={UserSpecificCategories}
              permissions={currentPermissions}
              permissionRequired="Whatsapp Campaign"
              authUser={authUser}
            />
          </Switch>
        )}
      </>
    </Router>
  );
};

export default MainRouter;
